import { ExtendedCardType } from 'owa-mail-reading-pane-store/lib/store/schema/ExtendedCardViewState';
import loc from 'owa-localize';
import {
    collapse_actionText,
    expand_actionText,
    yammer_collapse_actionText,
    yammer_expand_actionText,
} from './getActionBarText.locstring.json';

export default function getActionBarText(cardType: ExtendedCardType, isCollapsed: boolean): string {
    let textName = '';
    switch (cardType) {
        case ExtendedCardType.Yammer:
            textName = isCollapsed ? yammer_expand_actionText : yammer_collapse_actionText;
            break;
        default:
            textName = isCollapsed ? expand_actionText : collapse_actionText;
            break;
    }

    return loc(textName);
}
